module.exports = __webpack_public_path__ + "static/service-3-d5490e3834ab52b7c0a0fa47c427ce0f.svg";